module.exports = __webpack_public_path__ + "static/assets/3e872fc64bbebf5ca604994611735e01.svg";